import {
  useRApplicationUploadImage,
  UseRApplicationUploadImageOptions,
} from '@repositories/new-application';
import dataUrlToFile from '@utils/file/data-url-to-file';
import { ApplicationCameraProps } from '../types';

interface UseUploadImageOptions {
  name: ApplicationCameraProps['name'];
  onError?: UseRApplicationUploadImageOptions['onError'];
  onSuccess?: UseRApplicationUploadImageOptions['onSuccess'];
}

function useUploadImage({ name, onError, onSuccess }: UseUploadImageOptions) {
  const { mutateAsync, isLoading } = useRApplicationUploadImage({
    onError,
    onSuccess,
  });

  async function uploadImage(imageBase64: string) {
    const file = dataUrlToFile(
      imageBase64,
      `${new Date().getTime()}${Math.random() * 10}.jpg`,
    );

    if (!file) return;

    await mutateAsync({
      variables: {
        file,
        imageType: name === 'selfieKtp' ? 'selfie' : 'ktp_self',
      },
    });
  }

  return {
    uploadImage,
    isUploadingImage: isLoading,
  };
}

export default useUploadImage;
